module.exports = __webpack_public_path__ + "img/policies-tick.923b1448.png";